var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidentialSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7562,
    cy: 13.2397,
    r: 12.5,
    fill: "#2962FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9608 18.0157L16.8926 20.0838L16.2006 19.3918L17.0581 18.5152H14.7656V17.5209H17.0613L16.2038 16.6427L16.8958 15.9507L18.9608 18.0157ZM17.7772 10.4795V12.5636H16.3644V11.1859L12.1247 8.00406L7.8849 11.1859V17.5495H12.411V18.9527H6.47217V10.4795L12.1247 6.23975L17.7772 10.4795Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5682,
    height: 14,
    fill: "white",
    transform: "translate(6.47217 6.23975)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialSeller);
export default __webpack_public_path__ + "static/media/Residential_seller.93114c8b3a5f8781332cbedea7e1eaa2.svg";
export { ForwardRef as ReactComponent };